<template>
  <a-layout-content>
    <a-layout style="background: var(--bodyBackgroundColor)">
      <!--Menu-->
      <a-layout-sider breakpoint="md" collapsed-width="0" class="a-layout-sider--absolute" :style="{
        background: 'var(--bodyBackgroundColor)',
        width: '240px',

        minWidth: '0px',
      }">

        <a-menu @click="handleMenuClick" v-model="selectedMenuKey" mode="inline" style="height: 100%">
          <a-menu-item v-for="menu in menus" :key="menu.label">
            <a-tooltip placement="right" :title="menu.title + ' ' + allCount[menu.name + 'Count']"
              style="height: 100%; width: 100%">
              <span v-if="allCount[menu.name + 'Count'] > 0" style="margin-right: 5px">
                <a-badge :numberStyle="{ backgroundColor: 'rgb(208, 211, 211)' }"
                  :count="allCount[menu.name + 'Count']" />
              </span>

              <a-icon v-else :type="menu.icon" />

              {{ menu.title.slice(0, 27) }}
            </a-tooltip>
          </a-menu-item>
        </a-menu>
      </a-layout-sider>

      <!--Counts info-->
      <a-layout-content :style="{ padding: '0 10px', minHeight: '280px' }">
        <div style="float: right; margin-bottom: 10px; padding-right: 10px" v-if="selectedMenuKey[0] == 'aall'">
          <div>
            <span style="font-weight: 500; color: var(--textColor)">Şikayət sayı -</span>
            <em style="font-weight: 500; color: var(--resultTextColor)">{{
              counts.totalCount
            }}</em>
          </div>
        </div>

        <!--   <div
          v-if="currentStep.canAddNewRequest"
          style="text-align: end;"
          @click="goNewReqPg"
        >
          <a-button type="primary" class="btn-adr">Yeni müraciət</a-button>
        </div> -->

        <!--Search collapse panel-->
        <a-collapse :bordered="false">
          <a-collapse-panel header='Axtar ' class="search-collapse" key="search" style="padding-bottom: 10px">
            <a-icon slot="extra" type="search" />
            <a-row :gutter="24">
              <!--Executive selection-->
              <a-col :xs="{ span: 20 }" :sm="{ span: 12 }" :lg="{ span: 6 }" v-if="(selectedMenuKey[0] == 'all' || selectedMenuKey[0] == 'completed') &&
                currentStep.canSearchByExecutive
                ">
                <div>Yerli icra hakimiyyəti orqanı:</div>
                <a-select showSearch @search="searchStructures" :filterOption="false" allowClear
                  notFoundContent="Məlumat tapılmadı" @change="handleExecutiveChange" style="width: 100%"
                  placeholder="İcra orqanını seçin">
                  <a-select-option v-for="(executive, index) in filterExecutives"
                    style="white-space: wrap; text-overflow: initial" :key="'executive' + index" :value="executive.id">{{
                      executive.name }}</a-select-option>
                </a-select>
              </a-col>

              <a-col :xs="{ span: 20 }" :sm="{ span: 12 }" :lg="{ span: 6 }"
                v-if="selectedMenu && selectedMenu.type == 'REQUEST'">
                <div>Müraciət növü:</div>

                <select name="" id="custom__select" @change="getType($event)">

                  <option value="NEW"> Yeni müraciət</option>
                  <option value="JOIN"> Qoşulmuş müraciət</option>
                </select>
                <!--                 <a-select
                  placeholder="Müraciət tipi"
                  showSearch
                  :allowClear="true"
                  :filterOption="false"
                  v-model="filters.type"
                  notFoundContent="Məlumat tapılmadı"
                  @change="getType"
                  style="width: 100%"
                >
                  <a-select-option
                  
                    style="white-space: wrap; text-overflow: initial"
                    key="new"
                    
                  >
                    Yeni müraciət
                  </a-select-option>
                  <a-select-option
                    style="white-space: wrap; text-overflow: initial"
                    key="JOIN"
                    value="JOIN"
                  >
                    Qoşulmuş müraciət
                  </a-select-option>
                </a-select> -->
              </a-col>

              <!--Representation selection-->
              <a-col :xs="{ span: 20 }" :sm="{ span: 12 }" :lg="{ span: 6 }" v-if="(selectedMenuKey[0] == 'all' || selectedMenuKey[0] == 'completed') &&
                currentStep.canSearchByRepresentation
                ">
                <div>Nümayəndəlik:</div>
                <a-select v-model="filters.representationId" @change="handleRepresentationChange" style="width: 100%"
                  placeholder="Nəzarətçi seçin" notFoundContent="Məlumat tapılmadı"
                  :disabled="filters.executiveId == null" allowClear>
                  <a-select-option v-for="(representation, index) in representations"
                    style="white-space: wrap; text-overflow: initial" :key="'representation' + index"
                    :value="representation.id">{{ representation.name }}</a-select-option>
                </a-select>
              </a-col>

              <!--Offices-->
              <a-col :xs="{ span: 20 }" :sm="{ span: 12 }" :lg="{ span: 6 }" v-if="currentStep.canSearchByParentOffice &&
                (selectedMenuKey[0] == 'all' || selectedMenuKey[0] == 'late' || selectedMenuKey[0] == 'completed')
                ">
                <div>Qurumlar:</div>
                <a-select showSearch @change="handleOfficeChange" @search="searchOraqnizations" :filterOption="false"
                  style="width: 100%" :allowClear="true" notFoundContent="Məlumat tapılmadı" placeholder="Qurumlar seçin">
                  <a-select-option v-for="(office, index) in filterOrqanizations"
                    style="white-space: wrap; text-overflow: initial" :key="'office' + index" :value="office.id">{{
                      office.name }}</a-select-option>
                </a-select>
              </a-col>

              <!--Sub office selection-->
              <a-col :xs="{ span: 20 }" :sm="{ span: 12 }" :lg="{ span: 6 }" v-if="(selectedMenuKey[0] == 'all' || selectedMenuKey[0] == 'completed') &&
                currentStep.canSearchBySuboffice
                ">

                <div>Tabeli qurum:</div>
                <a-select v-model="filters.officeId" @change="handleSubOfficeChange" style="width: 100%" allowClear
                  notFoundContent="Məlumat tapılmadı" placeholder="Tabeli qurumu seçin">
                  <a-select-option v-for="(office, index) in offices" style="white-space: wrap; text-overflow: initial"
                    :key="'office' + index" :value="office.id">{{ office.name }}</a-select-option>
                </a-select>
              </a-col>

              <!--Executors auto complete-->
              <a-col :xs="{ span: 20 }" :sm="{ span: 12 }" :lg="{ span: 6 }"
                v-if="(selectedMenuKey[0] == 'all' || selectedMenuKey[0] == 'completed') && currentStep.canSearchByExecutor">
                <div>Birbaşa icraçı:</div>

                <a-select v-model="filters.executorUUID" style="width: 100%" placeholder="İcraçı seçin" allowClear
                  notFoundContent="Məlumat tapılmadı" @change="handleExecutorChange">
                  <a-select-option v-for="(executor, index) in executors"
                    style="white-space: wrap; text-overflow: initial" :key="'executor' + index" :value="executor.uuid">
                    {{
                      executor.firstName +
                      " " +
                      executor.lastName +
                      " (" +
                      executor.taskCount +
                      " tapşırıq)"
                    }}
                  </a-select-option>
                </a-select>
              </a-col>

              <!--Step select -->
              <a-col :xs="{ span: 20 }" :sm="{ span: 12 }" :lg="{ span: 6 }"
                v-if="(selectedMenuKey[0] == 'all' || selectedMenuKey[0] == 'completed')">
                <div>İcra gedişatı:</div>
                <a-select notFoundContent="Məlumat tapılmadı" allowClear @change="changeFilterStep" style="width: 100%"
                  placeholder="İcra gedişatı seçin">
                  <a-select-option v-for="step in steps" style="white-space: wrap; text-overflow: initial" :key="step.id"
                    :value="step.id">{{ step.name }}</a-select-option>
                </a-select>
              </a-col>

              <!--Priority selection-->
              <a-col :xs="{ span: 20 }" :sm="{ span: 12 }" :lg="{ span: 6 }"
                v-if="(selectedMenuKey[0] == 'all' || selectedMenuKey[0] == 'completed')">
                <div>Prioritetlik:</div>
                <a-select notFoundContent="Məlumat tapılmadı" @change="changeFilterPriority" style="width: 100%"
                  placeholder="Prioritetlik seçin" :allowClear="true">
                  <a-select-option v-for="priority in priorityLevels" style="white-space: wrap; text-overflow: initial"
                    :key="priority.name" :value="priority.name">
                    {{ priority.title }}
                    <span class="prioritet-circle" :style="{ backgroundColor: priority.color }">
                    </span>
                  </a-select-option>
                </a-select>
              </a-col>

              <!--Date selection-->
              <a-col :xs="{ span: 20 }" :sm="{ span: 12 }" :lg="{ span: 6 }">
                <div>Tarix aralığı:</div>
                <a-range-picker style="width: 100%" @change="changeFilterDate" :allowClear="true" show-time
                  :disabled-date="disabledDate" format="DD.MM.YYYY HH:mm:ss"
                  :placeholder="['Başlangıc tarix', 'Son tarix']" v-model="filters.date" :locale="locale" />
              </a-col>

              <!--Completed or nor type select-->
              <a-col :xs="{ span: 20 }" :sm="{ span: 12 }" :lg="{ span: 6 }"
                v-if="(selectedMenuKey[0] == 'all' || selectedMenuKey[0] == 'completed')">
                <div>İcra vəziyyəti:</div>
                <a-select notFoundContent="Məlumat tapılmadı" style="width: 100%" placeholder="İcra vəziyyəti seçin"
                  @change="changeFilterType" :allowClear="true">
                  <a-select-option :key="'completed'" value="completed">İcra olunmuşlar</a-select-option>
                  <a-select-option :key="'uncompleted'" value="uncompleted">İcrada olan</a-select-option>
                </a-select>
              </a-col>
              <!--               <a-col
              v-if="selectedMenuKey[0] == 'all'"
               :xs="{ span: 20 }" :sm="{ span: 12 }" :lg="{ span: 6 }">
                <div>İcra olunmuş tarix:</div>
                <input
                  style="
                  width:100%;
                    padding: 2px;
                    border: 0.1px solid rgb(198 198 198);
                    border-radius:4px
                  "
                  type="date"
                  name=""
                  id=""
                />
              </a-col> -->
              <a-col :xs="{ span: 20 }" :sm="{ span: 12 }" :lg="{ span: 6 }" v-if="(selectedMenuKey[0] == 'all' || selectedMenuKey[0] == 'completed') && currentStep.canSearchByCategory
                ">
                <div>Müraciətin təsnifatı:</div>
                <a-tree-select show-search style="width: 100%" allow-clear @search="handleCatSearch"
                  treeNodeFilterProp='title' tree-default-expand-all
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="Müraciətin təsnifatını seçin"
                  @change="changeCategory" :show-checked-strategy="SHOW_PARENT">
                  <a-tree-select-node v-for="cat in categories" :key="cat.id" :value="cat.id" :title="cat.name"
                    style="white-space: wrap; text-overflow: initial">
                    <a-tree-select-node v-for="subcat in cat.subCategories" :key="subcat.id" :value="subcat.id"
                      :title="subcat.name" style="white-space: wrap; text-overflow: initial">
                      <a-tree-select-node v-for="ssubcat in subcat.subCategories"
                        style="white-space: wrap; text-overflow: initial" :key="ssubcat.id" :value="ssubcat.id"
                        :title="ssubcat.name">
                      </a-tree-select-node>
                    </a-tree-select-node>
                  </a-tree-select-node>
                </a-tree-select>
              </a-col>

              <a-col :xs="{ span: 20 }" :sm="{ span: 12 }" :lg="{ span: 6 }" v-if="selectedMenu">
                <div>Müraciət nömrəsi:</div>
                <a-input :allowClear="true" style="width: 100%" placeholder="Müraciət nömrəsini daxil edin"
                  @input="debounceInputR" type="number">
                </a-input>
              </a-col>

              <a-col :xs="{ span: 20 }" :sm="{ span: 12 }" :lg="{ span: 6 }"
                v-if="selectedMenu && selectedMenu.type === 'PROBLEM'">
                <div>Şikayət nömrəsi:</div>
                <a-input style="width: 100%" placeholder="Şikayət nömrəsini daxil edin" @input="debounceInput"
                  :allowClear="true" type="number">
                </a-input>
              </a-col>
              <a-col :xs="{ span: 20 }" :sm="{ span: 12 }" :lg="{ span: 6 }" v-if="selectedMenu &&
                currentStep.canSearchByExecStructCount &&
                selectedMenu.type === 'PROBLEM'
                ">
                <div>Bir neçə quruma göndərilən:</div>
                <a-input v-model="IcraciTeskilat" style="width: 100%" placeholder="Bir neçə quruma göndərilən daxil edin"
                  @input="debounceInput5" :allowClear="true" type="number">
                </a-input>
              </a-col>
              <a-col :xs="{ span: 20 }" :sm="{ span: 12 }" :lg="{ span: 6 }" v-if="selectedMenu &&
                selectedMenu.type === 'PROBLEM' &&
                currentStep.canSearchByVerifiedDate
                ">
                <div>Quruma göndərilmə tarixi:</div>
                <a-date-picker @change="handleVDateChange" format="DD.MM.YYYY" style="width: 100%"
                  placeholder="Təsdiqləmə tarixi seçin" v-model="filters.verifiedDate" :locale="locale" />
              </a-col>
              <a-col v-if="(selectedMenuKey[0] == 'all' || selectedMenuKey[0] == 'completed')" :xs="{ span: 20 }"
                :sm="{ span: 12 }" :lg="{ span: 6 }">
                <div>
                  <p style="margin: 0">İcra nəticəsi:</p>

                  <a-select @change="switchChange" style="width: 100%" :allowClear="true">
                    <a-select-option :key="1" value="executionResultWithFiles">
                      İcra nəticəsi (fayl ilə)
                    </a-select-option>
                    <a-select-option :key="2" value="officeExecutionResult">
                      İcra nəticəsi (faylsız)
                    </a-select-option>

                    <a-select-option :key="3" value="officeExecutionResultNull">
                      İcra nəticəsi olmayan
                    </a-select-option>
                  </a-select>

                  <!--  <a-switch @change="switchChange" /> -->
                </div>
              </a-col>
              <a-col :xs="{ span: 20 }" :sm="{ span: 12 }" :lg="{ span: 6 }"
                v-if="selectedMenuKey[0] == 'allreq' || (selectedMenuKey[0] == 'all' || selectedMenuKey[0] == 'completed')">
                <div>Vətəndaş:</div>
                <a-auto-complete style="width: 100%" placeholder="Vətəndaş axtarışı" @select="onCitizenSelect"
                  @search="onCitizenSearch" @change="onCitizenChange" v-model="citizen" allowClear>
                  <template slot="dataSource">
                    <a-select-option :key="citizen.uuid" v-for="citizen in citizenFilterList">
                      {{ citizen.firstName }} {{ citizen.lastName }},
                      {{ citizen.fatherName }}
                    </a-select-option>
                  </template>
                </a-auto-complete>
              </a-col>
            </a-row>
          </a-collapse-panel>
        </a-collapse>

        <!--Data table-->
        <problems-table v-if="selectedMenu && selectedMenu.type === 'PROBLEM'" ref="problemsTable" :dataSource="data"
          @change="handleTableChange" :loading="loading" :canEdit="selectedMenu ? selectedMenu.canEdit : false"
          :selectedMenu="selectedMenu" :totalCount="searchResultCount" />

        <citizen-requests v-if="selectedMenu && selectedMenu.type === 'REQUEST'" ref="requestsTable" :loading="loading"
          @change="handleTableChange" :dataSource="data" :totalCount="searchResultCount" :url="selectedMenu.url"
          :canEdit="selectedMenu.canEdit" :selectedMenu="selectedMenu" />
      </a-layout-content>
    </a-layout>
  </a-layout-content>
</template>

<script>
// import { mapGetters, mapMutations, mapActions } from "vuex";
// import AppLeftSidebar from "@/components/partials/AppLeftSidebar.vue";
import { URL, apiCall } from "@/utils/api";
import moment from "moment";
import mixin from "@/mixins/index";
// import GLOBALS from "../../../global/store";
import CitizenRequestsTable from "@/components/partials/CitizenRequestsTable/index";
import ProblemsTable from "@/components/partials/ProblemsTable/index";
import { debounce } from "debounce";
import { TreeSelect } from "ant-design-vue";
import EventBus from "@/EventBus";
import locale from "ant-design-vue/es/date-picker/locale/en_US";
import axios from "axios";
import { io } from "socket.io-client";
// import io from "socket.io-client";

import globalLocale from "ant-design-vue/es/locale/en_US";

import { mapMutations } from "vuex";

const getCitizenFilterList = async (search) => {
  try {
    const res = await axios.get("http://10.60.20.22:8080/easyappeal/citizens", {
      params: { str: search },
    });


  } catch (_error) { }
};

const SHOW_PARENT = TreeSelect.SHOW_PARENT;

export default {
  name: "Main",
  mixins: [mixin],
  components: {
    "problems-table": ProblemsTable,
    "citizen-requests": CitizenRequestsTable,
  },
  data() {

    return {
      session:
        sessionStorage.getItem("cmit") === "all" ? "Şikayət" : "Müraciət",
      sessionText:
        sessionStorage.getItem("cmit") === "all"
          ? "Şikayət nömrəsini daxil edin"
          : "Müraciət nömrəsini daxil edin",
      sessionText2:
        sessionStorage.getItem("cmit") === "all"
          ? "Şikayətin təsnifatını seçin"
          : "Müraciətin təsnifatını seçin",

      citizenFilter: null,
      citizenFilterList: [],
      selectedMenu: null,
      loading: false,
      problems: [],
      data: [],
      dataTotalCount: 0,
      regionsAll: [],
      filteredRegions: [],
      counts: {},
      selectedMenuKey: [],
      filters: null,
      filterStreets: [],
      streetsAll: [],
      steps: [],
      executors: [],
      executives: [],
      filterExecutives: [],
      filterOrqanizations: [],
      priorities: [],
      employees: [],
      operationStatuses: [],
      menus: [],
      parentOffices: [],
      offices: [],
      representations: [],
      allCount: {},
      streetSpin: false,
      searchResultCount: null,
      categories: [],
      SHOW_PARENT,
      pagination: { pageSize: 10, current: 1, position: "both" },
      sorter: undefined,
      IcraciTeskilat: null,
      officeExecutionResult: undefined,
      oldFilters: null,
      citizen: '',
      locale: {
        ...locale,
        lang: {
          ...locale.lang,
          timeSelect: "Vaxt seçin",
          ok: "Təsdiq",
        },
      },
    };
  },

  watch: {
    locale: {
      immediate: true,
      handler: function (val) {

      },
    },

    filters: {
      deep: true,
      handler: function (_newValue) {
        this.officeExecutionResult = undefined;
        this.getProblems();
      },
    },
  },

  computed: {

    tableCommonRef: function () {
      if (!this.selectedMenu) return;
      return this.selectedMenu.type
        ? this.$refs.problemsTable
        : this.$refs.requestsTable;
    },
  },

  methods: {
    playSound(sound) {
      if (sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
    connect() {
      if (sessionStorage.getItem("userGroupType") == 1) {
        this.socket = io(URL[process.env.NODE_ENV].socket_origin,
          {
            extraHeaders: {
              userId: this.user.uuid,
              stepId: this.currentStep.id
            }
          }
        );
        this.socket.on("new_request", (mes) => {
          console.log(mes);
          this.getCounts();
          this.playSound('/sound/sound.mp3')
        });

        this.socket.on('request_opened', (params) => {
          EventBus.$emit("opened", { ...params });

        })
      }
    },
    handleCatSearch(val) {

    },



    async townSearch(searchText) {

      try {


        const res = await axios.get(
          `${URL[process.env.NODE_ENV].service_api}citizens`,
          {
            params: { keyword: searchText },
          }
        );

        this.citizenFilterList = res.data.data;
      } catch (_error) {
        this.citizenFilterList = [];
      }
    },

    onCitizenSearch: debounce(function (e) {
      this.townSearch(e)

    }, 500),
    onCitizenSelect(value) {
      this.filters = { ...this.filters, uuid: value };
    },

    onCitizenChange(value) {

      if (!value) this.filters = { ...this.filters, uuid: undefined };
    },
    switchChange(val) {
      this.officeExecutionResult = val;
      this.getProblems();
    },
    moment,
    disabledDate(current) {
      // Can not select days before today and today
      return current && current < moment("01.04.2021", "DD.MM.YYYY");
    },
    handleVDateChange(e) {
      this.pagination.current = 1;
      this.getProblems();
    },
    getSubOffices() {
      apiCall({
        url: URL[process.env.NODE_ENV].auth_api + "structures/suboffices",
      })
        .then((response) => {
          if (!response.data.error) {
            this.offices = response.data.data.entities;
          }
        })
        .catch((err) => {
          this.$message.error("Xəta baş verdi");
          console.log(err);
        });
    },
    async getMenus() {
      await apiCall({
        url: URL[process.env.NODE_ENV].service_api + "common/menus",
        method: "GET",
      })
        .then((response) => {
          this.menus = response.data.data;
          let selMenuKey = sessionStorage.getItem("cmit");
          if (selMenuKey) {
            this.selectedMenuKey = [selMenuKey];
            this.selectedMenu = this.menus.find(
              (menu) => menu.label === selMenuKey
            );
          }
          if (!this.selectedMenu) {
            this.selectedMenu = this.menus[0];
            this.selectedMenuKey = [this.selectedMenu.label];
            sessionStorage.setItem("cmit", this.selectedMenu.label);
          }
          this.getProblems();

          this.getFilterDatas();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getFilterDatas() {
      if (this.selectedMenuKey[0] === "all") {
        this.getSteps();
        this.getExecutors();
        this.getExecutives();
        this.getCategoriesList();
        if (
          this.user.structure.type.label === "OFFICE" ||
          this.user.structure.type.label === "EXECUTIVE"
        )
          this.getChildrenOffices(this.user.structure.id);
      }

      this.getExecStructures();
    },
    async getCategoriesList() {
      this.getCategories().then((response) => {
        if (!response.data.error) {
          this.categories = response.data.data.entities;
        }
      });
    },
    async getExecStructures() {
      apiCall({
        url: URL[process.env.NODE_ENV].auth_api + "structures/execStructures",
        method: "GET",
      })
        .then((response) => {
          this.$store.dispatch("user/setamis", response.data?.data.structureName)

          if (!response.data.error)
            this.filterOrqanizations = response.data.data.entities;
          this.parentOffices = response.data.data.entities;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getChildrenOffices(parentOfficeId) {
      if (!parentOfficeId) return;
      apiCall({
        url: URL[process.env.NODE_ENV].auth_api + "structures/subExecStructure",
        params: { parentId: parentOfficeId },
      })
        .then((response) => {

          if (!response.data.error) this.offices = response.data.data.entities;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getRepresentations(executiveId) {
      if (!executiveId) return;
      apiCall({
        url: URL[process.env.NODE_ENV].auth_api + "structures/representations",
        params: { parentId: executiveId },
      })
        .then((response) => {
          if (!response.data.error)
            this.representations = response.data.data.entities;
        })
        .catch((err) => console.log(err));
    },
    resetPagination() {
      if (this.selectedMenu.type === "REQUEST" && this.$refs.requestsTable)
        this.$refs.requestsTable.pagination.current = 1;
      else if (this.$refs.problemsTable)
        this.$refs.problemsTable.pagination.current = 1;
    },
    async getProblems() {
      if (!this.selectedMenu) return;

      if (
        this.oldFilters &&
        JSON.stringify(this.filters) !== JSON.stringify(this.oldFilters)
      ) {
        this.pagination.current = 1;
        this.resetPagination();
      }
      this.data = [];
      this.loading = true;
      await apiCall({
        url:
          URL[process.env.NODE_ENV].service_api +
          `${this.selectedMenu.type.toLowerCase() + "s"}`,
        method: "GET",
        params: {
          menu: this.selectedMenu.label,
          startDateStr:
            this.filters.date[0] !== undefined
              ? this.filters.date[0].format("DD.MM.YYYY HH:mm:ss")
              : null,
          endDateStr:
            this.filters.date[1] !== undefined
              ? this.filters.date[1].format("DD.MM.YYYY  HH:mm:ss")
              : null,
          problemNumber: this.filters.number ? this.filters.number : null,
          max: this.pagination.pageSize,
          offset: (this.pagination.current - 1) * this.pagination.pageSize,
          sortBy: this.sorter && "date",
          order: this.sorter,
          completed: this.filters.type != null ? this.filters.type : null,
          priority: this.filters.priorityId ? this.filters.priorityId : null,
          statusId: this.filters.statusId ? this.filters.statusId : null,
          parentOfficeId: this.filters.parentOfficeId
            ? this.filters.parentOfficeId
            : null,
          officeId: this.filters.officeId ? this.filters.officeId : null,
          regionId: this.filters.regionId ? this.filters.regionId : null,
          streetId: this.filters.streetId ? this.filters.streetId : null,
          categoryId: this.filters.categoryId ? this.filters.categoryId : null,
          requestNumber: this.filters.reqNumber ? this.filters.reqNumber : null,
          executorUUID: this.filters.executorUUID
            ? this.filters.executorUUID
            : null,
          executiveId: this.filters.executiveId
            ? this.filters.executiveId
            : null,
          representationId: this.filters.representationId
            ? this.filters.representationId
            : null,
          stepId: this.filters.stepId ? this.filters.stepId : null,
          verifiedDateStr: this.filters.verifiedDate
            ? this.filters.verifiedDate.format("DD.MM.YYYY")
            : null,
          citizenUUID: this.filters.uuid,
          type: this.filters.type,
          execStructCount: this.IcraciTeskilat,
          officeExecutionResult: this.officeExecutionResult,
        },
      })
        .then((response) => {
          /*   console.log(this.searchResultCount,); */
          this.oldFilters = { ...this.filters };
          this.searchResultCount = response.data.data.totalCount;
          this.data = response.data.data.entities;
          this.counts.totalCount = response.data.data.totalCount;
          this.loading = false;

        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("Xəta baş verdi");
          console.log(err);
        });
    },
    getType(val) {
      this.filters.type = val.target.value

      this.getProblems();
    },
    async getExecutors() {
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "executors",
        method: "GET",
      })
        .then((response) => {
          if (!response.data.error) {
            this.executors = response.data.data.entities;
          } else this.$message.error(response.data.error.message);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleExecutorChange(key) {
      this.filters.executorUUID = key;
      this.pagination.current = 1;
      this.getProblems();
    },
    handleMenuClick(e) {
      this.selectedMenu = this.menus.find((element) => {
        return element.label === e.key;
      });
      sessionStorage.setItem("cmit", this.selectedMenu.label);
      if (this.pagination) this.pagination.current = 1;
      this.resetPagination();
      this.clearFilter();
      /*   this.getProblems(); */
      this.citizen = ''
      this.selectedMenuKey = [this.selectedMenu.label];
      this.getFilterDatas();
    },
    handleTableChange({ pagination, filters, sorter }) {
      this.pagination = { ...pagination, position: "both" };
      if (sorter.order) this.sorter = sorter.order.split("end")[0];
      this.getProblems();
    },
    debounceInput: debounce(function (e) {
      const numberFilter = e.target.value;

      /* if (+numberFilter > 999999) this.filters.number = 999999; */
    /*   else  */this.filters.number = numberFilter;

      // this.filters.number = e.target.value;
      this.getProblems();
    }, 500),

    debounceInput5: debounce(function (e) {
      if (this.IcraciTeskilat > 30) {
        this.IcraciTeskilat = null;
      } else {
        this.getProblems();
      }
    }, 500),
    debounceInputR: debounce(function (e) {
      // console.log("number field", val);\

      /* 
            if (+numberFilter > 999999) this.filters.reqNumber = 999999; */
      /*   else  */
      // this.filters.reqNumber = +val;
      if (e.target.value > 0) {
        this.filters.reqNumber = e.target.value;
        this.pagination.current = 1;
        this.getProblems();
      }

    }, 500),
    searchStreets(value) {
      // let smallValue = value.toLowerCase();
      clearTimeout(this.strSearchTimeout);
      this.strSearchTimeout = setTimeout(() => {
        this.streetSpin = true;
        this.getStreets(this.filters.regionId, value, null);
      }, 2000);
    },
    searchStructures(value) {
      this.filterExecutives = this.executives.filter(
        (item) => item.name.toLowerCase().indexOf(value.toLowerCase()) > -1
      );
    },
    searchOraqnizations(value) {
      console.log(this.parentOffices);
      this.filterOrqanizations = this.parentOffices.filter(
        (item) => item.name.toLowerCase().indexOf(value.toLowerCase()) > -1
      );
    },
    changeFilterStep(value) {
      this.filters.stepId = value;
      this.pagination.current = 1;
      this.getProblems();
    },
    changeCategory(value, label, extra) {

      this.filters.categoryId = value;
      this.pagination.current = 1;
      this.getProblems();
    },
    changeFilterType(value) {
      if (value === "completed") {
        this.filters.type = true;
      } else if (value === "uncompleted") {
        this.filters.type = false;
      } else {
        this.filters.type = null;
      }
      this.pagination.current = 1;
      this.getProblems();
    },
    changeFilterDate(obj, str) {
      // this.filters.date = obj;
      this.pagination.current = 1;
      this.getProblems();
    },
    changeFilterPriority(value) {
      this.filters.priorityId = value;
      this.pagination.current = 1;
      this.getProblems();
    },
    searchRegions(value) {
      this.filteredRegions = this.regions.filter(
        (item) => item.name.toLowerCase().indexOf(value.toLowerCase()) > -1
      );
    },
    changeFilterOperationStatus(value) {
      this.filters.statusId = value;
      this.pagination.current = 1;
      this.getProblems();
    },
    handleOfficeChange(val) {

      this.filters.parentOfficeId = val;
      this.filters.officeId = undefined;
      if (val) {
        this.getChildrenOffices(val);
      } else {
        this.offices = []
      }
      this.pagination.current = 1;
      this.getProblems();
    },
    changeFilterRegions(val) {
      this.filters.regionId = val;
      if (!val) {
        this.filterStreets = [];
        this.filters.streetKey = undefined;
        this.filters.streetId = null;
      }
      this.pagination.current = 1;
      this.getProblems();
    },
    handleSubOfficeChange(val) {
      this.filters.officeId = val;
      this.pagination.current = 1;
      this.getProblems();
    },
    handleStreetChange(val) {
      if (val) {
        this.filters.streetId = isNaN(parseInt(val.substr(6)))
          ? null
          : parseInt(val.substr(6));
      }
      this.pagination.current = 1;
      this.getProblems();
    },
    handleRepresentationChange(val) {
      this.filters.representationId = val;
      this.pagination.current = 1;
      this.getProblems();
    },
    handleExecutiveChange(val) {
      this.filters.executiveId = val;
      if (val) {
        this.getRepresentations(val);
      } else {
        this.representations = [];
        this.filters.representationId = undefined;
      }
      this.pagination.current = 1;
      this.getProblems();
    },
    getCounts() {
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "problems/counts",
        method: "get",
      })
        .then((response) => {
          this.allCount = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goNewReqPg() {
      this.$router.push("/newrequest");
    },
    clearFilter() {
      this.pagination.current = 1;
      this.filters = {
        type: undefined,
        number: null,
        reqNumber: null,
        stepId: null,
        priorityId: null,
        statusId: null,
        type: null,
        userId: null,
        date: [],
        officeId: null,
        parentOfficeId: null,
        representationId: null,
        executiveId: null,
        executorUUID: null,
        categoryId: null,
        verifiedDate: null,
      };
    },
  },
  async created() {

    this.getSubOffices()
    this.clearFilter();
    this.getMenus();
    this.getCounts();
    this.getFilterDatas();
  },
  mounted() {



    this.connect();
    if (this.selectedMenu) {
      if (this.selectedMenu.type === "PROBLEM")
        this.pagination = this.$refs.problemsTable.pagination;
      else this.pagination = this.$refs.requestsTable.pagination;
    }

    /*     EventBus.$on("opened", (info) => {
          const { requestId, userFullName } = info;
    
          const index = this.data.findIndex((req) => req.id === requestId);
    
          this.$set(this.data, index, {
            ...this.data[index],
            editor: userFullName,
          });
        }); */

    EventBus.$on("returnToList", (data) => {
      const { requestId } = data;

      const index = this.data.findIndex((req) => req.id === requestId);

      this.$set(this.data, index, {
        ...this.data[index],
        editor: undefined,
      });
    });

    EventBus.$on("removeFromList", (data) => {
      const { requestId } = data;

      // const index = this.data.findIndex(req => req.id === requestId);
      this.data = this.data.filter((req) => req.id !== requestId);
      // this.data.splice(index, 1);
    });
  },
};
</script>

<style lang="scss" scoped src="./Main.scss"></style>
<style >
.ant-collapse>.ant-collapse-item>.ant-collapse-header .ant-collapse-extra {
  display: inline-block;
  margin-left: 15px;
  float: none;
}
</style>
